import { render, staticRenderFns } from "./onlineCoursePreview.vue?vue&type=template&id=3a371011&scoped=true&"
import script from "./onlineCoursePreview.vue?vue&type=script&lang=js&"
export * from "./onlineCoursePreview.vue?vue&type=script&lang=js&"
import style0 from "./onlineCoursePreview.vue?vue&type=style&index=0&id=3a371011&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a371011",
  null
  
)

export default component.exports